import { LocalizedText } from '@mews/framework';
import { FilterChip, IconName } from '@optimus-web/core';
import { AssistantFilterChipsKeys } from '../../entityKeys';
import { AssistantFilterChips } from '../../assistantSearchTypeFilters';
import { AssistantSearchType } from '../../assistantSearchTypes';

interface ResultFilterChipItemProps {
    type: AssistantSearchType | AssistantFilterChips;
    active: boolean;
    handleChipClick: (value: AssistantSearchType | AssistantFilterChips, active: boolean) => void;
}

export const ResultFilterChipItem = ({ type, active, handleChipClick }: ResultFilterChipItemProps) => (
    <FilterChip
        key={type}
        data-test-id={type}
        value={type}
        icon={active && type !== 'All' ? IconName.CrossClose : undefined}
        onClick={() => {
            handleChipClick(type, active);
        }}
        active={active}
    >
        <LocalizedText textKey={AssistantFilterChipsKeys[type]} />
    </FilterChip>
);
